import { render, staticRenderFns } from "./bindShipNum.vue?vue&type=template&id=092c6bc6&scoped=true"
import script from "./bindShipNum.vue?vue&type=script&lang=js"
export * from "./bindShipNum.vue?vue&type=script&lang=js"
import style0 from "./bindShipNum.vue?vue&type=style&index=0&id=092c6bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092c6bc6",
  null
  
)

export default component.exports